import { VehicleRegistrationServiceAjs } from './vehicle-registration.service.ajs';

interface VehicleRegistrationSettingsScope extends ng.IScope {
  activate        : () => void;
  deactivate      : () => void;
  purchaseRequests: () => void;
  requests        : number;
};

export function VehicleRegistrationSettingsCtrl (
  $state                : ng.ui.IStateService,
  $scope                : VehicleRegistrationSettingsScope,
  $translate            : ng.translate.ITranslateService,
  messages              : any,
  requests              : number,
  vehicleRegistrationApi: VehicleRegistrationServiceAjs
) {
  $scope.requests = requests;

  $scope.activate = function () : void {
    vehicleRegistrationApi.activate()
    .then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: $translate.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.LOOKUP')
      }), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.deactivate = function () : void {
    vehicleRegistrationApi.deactivate()
    .then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', {
        name: $translate.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.LOOKUP')
      }), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.purchaseRequests = function () : void {
    vehicleRegistrationApi.purchaseRequests()
    .then(() => {
      $state.reload();
    });
  };
};
